export const countries = [
  {"code": "CZ", "english": "Czechia", "czech": "Česko"},
  {"code": "SK", "english": "Slovakia", "czech": "Slovensko"},
  {"code": "UN", "english": "United Nations", "czech": "Organizace spojených národů"},
  {"code": "AF", "english": "Afghanistan", "czech": "Afghánistán"},
  {"code": "AX", "english": "Åland Islands", "czech": "Alandy"},
  {"code": "AL", "english": "Albania", "czech": "Albánie"},
  {"code": "DZ", "english": "Algeria", "czech": "Alžírsko"},
  {"code": "AS", "english": "American Samoa", "czech": "Americká Samoa"},
  {"code": "AD", "english": "Andorra", "czech": "Andorra"},
  {"code": "AO", "english": "Angola", "czech": "Angola"},
  {"code": "AI", "english": "Anguilla", "czech": "Anguilla"},
  {"code": "AQ", "english": "Antarctica", "czech": "Antarktida"},
  {"code": "AG", "english": "Antigua and Barbuda", "czech": "Antigua a Barbuda"},
  {"code": "AR", "english": "Argentina", "czech": "Argentina"},
  {"code": "AM", "english": "Armenia", "czech": "Arménie"},
  {"code": "AW", "english": "Aruba", "czech": "Aruba"},
  {"code": "AU", "english": "Australia", "czech": "Austrálie"},
  {"code": "AT", "english": "Austria", "czech": "Rakousko"},
  {"code": "AZ", "english": "Azerbaijan", "czech": "Ázerbájdžán"},
  {"code": "BS", "english": "Bahamas", "czech": "Bahamy"},
  {"code": "BH", "english": "Bahrain", "czech": "Bahrajn"},
  {"code": "BD", "english": "Bangladesh", "czech": "Bangladéš"},
  {"code": "BB", "english": "Barbados", "czech": "Barbados"},
  {"code": "BY", "english": "Belarus", "czech": "Bělorusko"},
  {"code": "BE", "english": "Belgium", "czech": "Belgie"},
  {"code": "BZ", "english": "Belize", "czech": "Belize"},
  {"code": "BJ", "english": "Benin", "czech": "Benin"},
  {"code": "BM", "english": "Bermuda", "czech": "Bermudy"},
  {"code": "BT", "english": "Bhutan", "czech": "Bhútán"},
  {"code": "BO", "english": "Bolivia (Plurinational State of)", "czech": "Bolívie"},
  {"code": "BQ", "english": "Bonaire, Sint Eustatius and Saba", "czech": "Bonaire, Svatý Eustach a Saba"},
  {"code": "BA", "english": "Bosnia and Herzegovina", "czech": "Bosna a Hercegovina"},
  {"code": "BW", "english": "Botswana", "czech": "Botswana"},
  {"code": "BV", "english": "Bouvet Island", "czech": "Bouvetův ostrov"},
  {"code": "BR", "english": "Brazil", "czech": "Brazílie"},
  {"code": "IO", "english": "British Indian Ocean Territory", "czech": "Britské indickooceánské území"},
  {"code": "BN", "english": "Brunei Darussalam", "czech": "Brunej"},
  {"code": "BG", "english": "Bulgaria", "czech": "Bulharsko"},
  {"code": "BF", "english": "Burkina Faso", "czech": "Burkina Faso"},
  {"code": "BI", "english": "Burundi", "czech": "Burundi"},
  {"code": "KH", "english": "Cambodia", "czech": "Kambodža"},
  {"code": "CM", "english": "Cameroon", "czech": "Kamerun"},
  {"code": "CA", "english": "Canada", "czech": "Kanada"},
  {"code": "CV", "english": "Cabo Verde", "czech": "Kapverdy"},
  {"code": "KY", "english": "Cayman Islands", "czech": "Kajmanské ostrovy"},
  {"code": "CF", "english": "Central African Republic", "czech": "Středoafrická republika"},
  {"code": "TD", "english": "Chad", "czech": "Čad"},
  {"code": "CL", "english": "Chile", "czech": "Chile"},
  {"code": "CN", "english": "China", "czech": "Čína"},
  {"code": "CX", "english": "Christmas Island", "czech": "Vánoční ostrov"},
  {"code": "CC", "english": "Cocos (Keeling) Islands", "czech": "Kokosové (Keelingovy) ostrovy"},
  {"code": "CO", "english": "Colombia", "czech": "Kolumbie"},
  {"code": "KM", "english": "Comoros", "czech": "Komory"},
  {"code": "CG", "english": "Congo", "czech": "Kongo"},
  {"code": "CD", "english": "Congo (Democratic Republic of the)", "czech": "Kongo (Demokratická republika)"},
  {"code": "CK", "english": "Cook Islands", "czech": "Cookovy ostrovy"},
  {"code": "CR", "english": "Costa Rica", "czech": "Kostarika"},
  {"code": "CI", "english": "Côte d'Ivoire", "czech": "Pobřeží slonoviny"},
  {"code": "HR", "english": "Croatia", "czech": "Chorvatsko"},
  {"code": "CU", "english": "Cuba", "czech": "Kuba"},
  {"code": "CW", "english": "Curaçao", "czech": "Curaçao"},
  {"code": "CY", "english": "Cyprus", "czech": "Kypr"},
  {"code": "CZ", "english": "Czechia", "czech": "Česko"},
  {"code": "DE", "english": "Germany", "czech": "Německo"},
  {"code": "DJ", "english": "Djibouti", "czech": "Džibutsko"},
  {"code": "DK", "english": "Denmark", "czech": "Dánsko"},
  {"code": "DM", "english": "Dominica", "czech": "Dominika"},
  {"code": "DO", "english": "Dominican Republic", "czech": "Dominikánská republika"},
  {"code": "EC", "english": "Ecuador", "czech": "Ekvádor"},
  {"code": "EG", "english": "Egypt", "czech": "Egypt"},
  {"code": "SV", "english": "El Salvador", "czech": "Salvador"},
  {"code": "GQ", "english": "Equatorial Guinea", "czech": "Rovníková Guinea"},
  {"code": "ER", "english": "Eritrea", "czech": "Eritrea"},
  {"code": "EE", "english": "Estonia", "czech": "Estonsko"},
  {"code": "SZ", "english": "Eswatini", "czech": "Eswatini"},
  {"code": "ET", "english": "Ethiopia", "czech": "Etiopie"},
  {"code": "FK", "english": "Falkland Islands (Malvinas)", "czech": "Falklandy (Malvíny)"},
  {"code": "FO", "english": "Faroe Islands", "czech": "Faerské ostrovy"},
  {"code": "FJ", "english": "Fiji", "czech": "Fidži"},
  {"code": "FI", "english": "Finland", "czech": "Finsko"},
  {"code": "FR", "english": "France", "czech": "Francie"},
  {"code": "GF", "english": "French Guiana", "czech": "Francouzská Guyana"},
  {"code": "PF", "english": "French Polynesia", "czech": "Francouzská Polynésie"},
  {"code": "TF", "english": "French Southern Territories", "czech": "Francouzská jižní a antarktická území"},
  {"code": "GA", "english": "Gabon", "czech": "Gabon"},
  {"code": "GM", "english": "Gambia", "czech": "Gambie"},
  {"code": "GE", "english": "Georgia", "czech": "Gruzie"},
  {"code": "GH", "english": "Ghana", "czech": "Ghana"},
  {"code": "GI", "english": "Gibraltar", "czech": "Gibraltar"},
  {"code": "GR", "english": "Greece", "czech": "Řecko"},
  {"code": "GL", "english": "Greenland", "czech": "Grónsko"},
  {"code": "GD", "english": "Grenada", "czech": "Grenada"},
  {"code": "GP", "english": "Guadeloupe", "czech": "Guadeloupe"},
  {"code": "GU", "english": "Guam", "czech": "Guam"},
  {"code": "GT", "english": "Guatemala", "czech": "Guatemala"},
  {"code": "GG", "english": "Guernsey", "czech": "Guernsey"},
  {"code": "GN", "english": "Guinea", "czech": "Guinea"},
  {"code": "GW", "english": "Guinea-Bissau", "czech": "Guinea-Bissau"},
  {"code": "GY", "english": "Guyana", "czech": "Guyana"},
  {"code": "HT", "english": "Haiti", "czech": "Haiti"},
  {"code": "HM", "english": "Heard Island and McDonald Islands", "czech": "Heardův ostrov a McDonaldovy ostrovy"},
  {"code": "VA", "english": "Holy See", "czech": "Svatý stolec"},
  {"code": "HN", "english": "Honduras", "czech": "Honduras"},
  {"code": "HK", "english": "Hong Kong", "czech": "Hongkong"},
  {"code": "HU", "english": "Hungary", "czech": "Maďarsko"},
  {"code": "IS", "english": "Iceland", "czech": "Island"},
  {"code": "IN", "english": "India", "czech": "Indie"},
  {"code": "ID", "english": "Indonesia", "czech": "Indonésie"},
  {"code": "IR", "english": "Iran (Islamic Republic of)", "czech": "Írán"},
  {"code": "IQ", "english": "Iraq", "czech": "Irák"},
  {"code": "IE", "english": "Ireland", "czech": "Irsko"},
  {"code": "IM", "english": "Isle of Man", "czech": "Ostrov Man"},
  {"code": "IL", "english": "Israel", "czech": "Izrael"},
  {"code": "IT", "english": "Italy", "czech": "Itálie"},
  {"code": "JM", "english": "Jamaica", "czech": "Jamajka"},
  {"code": "JP", "english": "Japan", "czech": "Japonsko"},
  {"code": "JE", "english": "Jersey", "czech": "Jersey"},
  {"code": "JO", "english": "Jordan", "czech": "Jordánsko"},
  {"code": "KZ", "english": "Kazakhstan", "czech": "Kazachstán"},
  {"code": "KE", "english": "Kenya", "czech": "Keňa"},
  {"code": "KI", "english": "Kiribati", "czech": "Kiribati"},
  {"code": "KP", "english": "Korea (Democratic People's Republic of)", "czech": "Severní Korea"},
  {"code": "KR", "english": "Korea (Republic of)", "czech": "Jižní Korea"},
  {"code": "KW", "english": "Kuwait", "czech": "Kuvajt"},
  {"code": "KG", "english": "Kyrgyzstan", "czech": "Kyrgyzstán"},
  {"code": "LA", "english": "Lao People's Democratic Republic", "czech": "Laos"},
  {"code": "LV", "english": "Latvia", "czech": "Lotyšsko"},
  {"code": "LB", "english": "Lebanon", "czech": "Libanon"},
  {"code": "LS", "english": "Lesotho", "czech": "Lesotho"},
  {"code": "LR", "english": "Liberia", "czech": "Libérie"},
  {"code": "LY", "english": "Libya", "czech": "Libye"},
  {"code": "LI", "english": "Liechtenstein", "czech": "Lichtenštejnsko"},
  {"code": "LT", "english": "Lithuania", "czech": "Litva"},
  {"code": "LU", "english": "Luxembourg", "czech": "Lucembursko"},
  {"code": "MO", "english": "Macao", "czech": "Macao"},
  {"code": "MG", "english": "Madagascar", "czech": "Madagaskar"},
  {"code": "MW", "english": "Malawi", "czech": "Malawi"},
  {"code": "MY", "english": "Malaysia", "czech": "Malajsie"},
  {"code": "MV", "english": "Maldives", "czech": "Maledivy"},
  {"code": "ML", "english": "Mali", "czech": "Mali"},
  {"code": "MT", "english": "Malta", "czech": "Malta"},
  {"code": "MH", "english": "Marshall Islands", "czech": "Marshallovy ostrovy"},
  {"code": "MQ", "english": "Martinique", "czech": "Martinik"},
  {"code": "MR", "english": "Mauritania", "czech": "Mauritánie"},
  {"code": "MU", "english": "Mauritius", "czech": "Mauricius"},
  {"code": "YT", "english": "Mayotte", "czech": "Mayotte"},
  {"code": "MX", "english": "Mexico", "czech": "Mexiko"},
  {"code": "FM", "english": "Micronesia (Federated States of)", "czech": "Mikronésie"},
  {"code": "MD", "english": "Moldova (Republic of)", "czech": "Moldavsko"},
  {"code": "MC", "english": "Monaco", "czech": "Monako"},
  {"code": "MN", "english": "Mongolia", "czech": "Mongolsko"},
  {"code": "ME", "english": "Montenegro", "czech": "Černá Hora"},
  {"code": "MS", "english": "Montserrat", "czech": "Montserrat"},
  {"code": "MA", "english": "Morocco", "czech": "Maroko"},
  {"code": "MZ", "english": "Mozambique", "czech": "Mosambik"},
  {"code": "MM", "english": "Myanmar", "czech": "Myanmar"},
  {"code": "NA", "english": "Namibia", "czech": "Namibie"},
  {"code": "NR", "english": "Nauru", "czech": "Nauru"},
  {"code": "NP", "english": "Nepal", "czech": "Nepál"},
  {"code": "NL", "english": "Netherlands", "czech": "Nizozemsko"},
  {"code": "NC", "english": "New Caledonia", "czech": "Nová Kaledonie"},
  {"code": "NZ", "english": "New Zealand", "czech": "Nový Zéland"},
  {"code": "NI", "english": "Nicaragua", "czech": "Nikaragua"},
  {"code": "NE", "english": "Niger", "czech": "Niger"},
  {"code": "NG", "english": "Nigeria", "czech": "Nigérie"},
  {"code": "NU", "english": "Niue", "czech": "Niue"},
  {"code": "NF", "english": "Norfolk Island", "czech": "Norfolk"},
  {"code": "MK", "english": "North Macedonia", "czech": "Severní Makedonie"},
  {"code": "MP", "english": "Northern Mariana Islands", "czech": "Severní Mariany"},
  {"code": "NO", "english": "Norway", "czech": "Norsko"},
  {"code": "OM", "english": "Oman", "czech": "Omán"},
  {"code": "PK", "english": "Pakistan", "czech": "Pákistán"},
  {"code": "PW", "english": "Palau", "czech": "Palau"},
  {"code": "PS", "english": "Palestine, State of", "czech": "Palestina"},
  {"code": "PA", "english": "Panama", "czech": "Panama"},
  {"code": "PG", "english": "Papua New Guinea", "czech": "Papua-Nová Guinea"},
  {"code": "PY", "english": "Paraguay", "czech": "Paraguay"},
  {"code": "PE", "english": "Peru", "czech": "Peru"},
  {"code": "PH", "english": "Philippines", "czech": "Filipíny"},
  {"code": "PN", "english": "Pitcairn", "czech": "Pitcairnovy ostrovy"},
  {"code": "PL", "english": "Poland", "czech": "Polsko"},
  {"code": "PT", "english": "Portugal", "czech": "Portugalsko"},
  {"code": "PR", "english": "Puerto Rico", "czech": "Portoriko"},
  {"code": "QA", "english": "Qatar", "czech": "Katar"},
  {"code": "RE", "english": "Réunion", "czech": "Réunion"},
  {"code": "RO", "english": "Romania", "czech": "Rumunsko"},
  {"code": "RU", "english": "Russian Federation", "czech": "Rusko"},
  {"code": "RW", "english": "Rwanda", "czech": "Rwanda"},
  {"code": "BL", "english": "Saint Barthélemy", "czech": "Svatý Bartoloměj"},
  {"code": "SH", "english": "Saint Helena, Ascension and Tristan da Cunha", "czech": "Svatá Helena, Ascension a Tristan da Cunha"},
  {"code": "KN", "english": "Saint Kitts and Nevis", "czech": "Svatý Kryštof a Nevis"},
  {"code": "LC", "english": "Saint Lucia", "czech": "Svatá Lucie"},
  {"code": "MF", "english": "Saint Martin (French part)", "czech": "Svatý Martin (francouzská část)"},
  {"code": "PM", "english": "Saint Pierre and Miquelon", "czech": "Saint-Pierre a Miquelon"},
  {"code": "VC", "english": "Saint Vincent and the Grenadines", "czech": "Svatý Vincenc a Grenadiny"},
  {"code": "WS", "english": "Samoa", "czech": "Samoa"},
  {"code": "SM", "english": "San Marino", "czech": "San Marino"},
  {"code": "ST", "english": "Sao Tome and Principe", "czech": "Svatý Tomáš a Princův ostrov"},
  {"code": "SA", "english": "Saudi Arabia", "czech": "Saúdská Arábie"},
  {"code": "SN", "english": "Senegal", "czech": "Senegal"},
  {"code": "RS", "english": "Serbia", "czech": "Srbsko"},
  {"code": "SC", "english": "Seychelles", "czech": "Seychely"},
  {"code": "SL", "english": "Sierra Leone", "czech": "Sierra Leone"},
  {"code": "SG", "english": "Singapore", "czech": "Singapur"},
  {"code": "SX", "english": "Sint Maarten (Dutch part)", "czech": "Svatý Martin (nizozemská část)"},
  {"code": "SK", "english": "Slovakia", "czech": "Slovensko"},
  {"code": "SI", "english": "Slovenia", "czech": "Slovinsko"},
  {"code": "SB", "english": "Solomon Islands", "czech": "Šalomounovy ostrovy"},
  {"code": "SO", "english": "Somalia", "czech": "Somálsko"},
  {"code": "ZA", "english": "South Africa", "czech": "Jihoafrická republika"},
  {"code": "GS", "english": "South Georgia and the South Sandwich Islands", "czech": "Jižní Georgie a Jižní Sandwichovy ostrovy"},
  {"code": "SS", "english": "South Sudan", "czech": "Jižní Súdán"},
  {"code": "ES", "english": "Spain", "czech": "Španělsko"},
  {"code": "LK", "english": "Sri Lanka", "czech": "Srí Lanka"},
  {"code": "SD", "english": "Sudan", "czech": "Súdán"},
  {"code": "SR", "english": "Suriname", "czech": "Surinam"},
  {"code": "SJ", "english": "Svalbard and Jan Mayen", "czech": "Špicberky a Jan Mayen"},
  {"code": "SE", "english": "Sweden", "czech": "Švédsko"},
  {"code": "CH", "english": "Switzerland", "czech": "Švýcarsko"},
  {"code": "SY", "english": "Syrian Arab Republic", "czech": "Sýrie"},
  {"code": "TW", "english": "Taiwan, Province of China", "czech": "Tchaj-wan"},
  {"code": "TJ", "english": "Tajikistan", "czech": "Tádžikistán"},
  {"code": "TZ", "english": "Tanzania, United Republic of", "czech": "Tanzanie"},
  {"code": "TH", "english": "Thailand", "czech": "Thajsko"},
  {"code": "TL", "english": "Timor-Leste", "czech": "Východní Timor"},
  {"code": "TG", "english": "Togo", "czech": "Togo"},
  {"code": "TK", "english": "Tokelau", "czech": "Tokelau"},
  {"code": "TO", "english": "Tonga", "czech": "Tonga"},
  {"code": "TT", "english": "Trinidad and Tobago", "czech": "Trinidad a Tobago"},
  {"code": "TN", "english": "Tunisia", "czech": "Tunisko"},
  {"code": "TR", "english": "Turkey", "czech": "Turecko"},
  {"code": "TM", "english": "Turkmenistan", "czech": "Turkmenistán"},
  {"code": "TC", "english": "Turks and Caicos Islands", "czech": "Turks a Caicos"},
  {"code": "TV", "english": "Tuvalu", "czech": "Tuvalu"},
  {"code": "UG", "english": "Uganda", "czech": "Uganda"},
  {"code": "UA", "english": "Ukraine", "czech": "Ukrajina"},
  {"code": "AE", "english": "United Arab Emirates", "czech": "Spojené arabské emiráty"},
  {"code": "GB", "english": "United Kingdom of Great Britain and Northern Ireland", "czech": "Spojené království"},
  {"code": "US", "english": "United States of America", "czech": "Spojené státy"},
  {"code": "UM", "english": "United States Minor Outlying Islands", "czech": "Menší odlehlé ostrovy USA"},
  {"code": "UY", "english": "Uruguay", "czech": "Uruguay"},
  {"code": "UZ", "english": "Uzbekistan", "czech": "Uzbekistán"},
  {"code": "VU", "english": "Vanuatu", "czech": "Vanuatu"},
  {"code": "VE", "english": "Venezuela (Bolivarian Republic of)", "czech": "Venezuela"},
  {"code": "VN", "english": "Viet Nam", "czech": "Vietnam"},
  {"code": "VG", "english": "Virgin Islands (British)", "czech": "Britské Panenské ostrovy"},
  {"code": "VI", "english": "Virgin Islands (U.S.)", "czech": "Americké Panenské ostrovy"},
  {"code": "WF", "english": "Wallis and Futuna", "czech": "Wallis a Futuna"},
  {"code": "EH", "english": "Western Sahara", "czech": "Západní Sahara"},
  {"code": "YE", "english": "Yemen", "czech": "Jemen"},
  {"code": "ZM", "english": "Zambia", "czech": "Zambie"},
  {"code": "ZW", "english": "Zimbabwe", "czech": "Zimbabwe"}
 ]